/**
 * Management → Billing Management。
 * 打开页面打 STATSIG.COMMON.VIEW，value=mgmt_billing_management。
 *
 * 正在用：Continue 跳转 Stripe Billing Portal。
 * 已不算：Support（已注释）、说明列表、改套餐/发票（在 Stripe 里）。
 */
export enum MgmtBillingManagementEvent {
    /** 点 Continue，进入 Stripe Billing Portal */
    CONTINUE = 'BILLING_MANAGEMENT_CONTINUE',
}
